<template>
  <div :class="classes"  v-loading="loading">
    <pt-page-title title="视频列表" :isSearch="true" @search="search" :searchKey="searchKey" @emptySearch="emptySearch">
      <el-button slot="before-left" type="primary" @click="toCreate">新建视频</el-button>
    </pt-page-title>
    <pt-page-factor-filter :labels="filterItems" v-model="filterCondition"  isQueryRouter @Filter="Filter" ref="filter">
      <template>
        <el-button type="primary" @click="Filter()">筛选</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter>
    <pt-video-manage-table :tableLabel="tableLabels" :params-data="paramsData" ref="tableWithData"  :isFromRouter="isFromRouter" :isSearch="isSearch">
      <template >
        <el-table-column label="在工具中心展示">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.visibleInTools" @change="updateVisible(scope.row)" :disabled="scope.row.status!=='APPROVED'"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <div :class="$style['opreation-button']" slot-scope="scope">
            <i class="iconfont icon-xiangqing" @click="goDetail(scope.row)"></i>
            <i class="iconfont icon-bianji"  @click="editItem(scope.row)"></i>
            <i class="iconfont icon-shanchu"  @click="deleteItem(scope.row)"></i>
            <el-button type="text" @click="preview(scope.row)">预览</el-button>
            <el-button type="text" @click="toSubmit(scope.row)" v-if="scope.row.status==='SCRIPT'">提交</el-button>
            <pt-copy-button type="text" :copyContent="$publicResourcesUrl + scope.row.contentUrl" text="复制链接" :class="$style['order-message-id']" v-if="scope.row.status==='SCRIPT'"></pt-copy-button>
          </div>
        </el-table-column>
      </template>
    </pt-video-manage-table>
    <review-poster-mobile :isVideo="true" :showDialog="showDialog" @closeDialog="showDialog = false" :detail="currentPoster"></review-poster-mobile>
  </div>
</template>

<script>
import reviewPosterMobile from 'cps/tool-operation/review-poster-mobile'
import ptVideoManageTable from './pt-video-manage-table/withData'
import { tableLabels, filterItems } from './options.js'
import { emptyObject } from '@/utils/lifebankUtils'
// 组件class前缀
const prefixCls = 'pt-video-manage'

export default {
  name: 'pt-video-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptVideoManageTable,
    reviewPosterMobile
  },
  data () {
    return {
      filterItems: filterItems,
      tableLabels: tableLabels,
      filterCondition: {},
      paramsData: {},
      isFromRouter: false,
      showDialog: false,
      currentPoster: {},
      searchKey: null,
      loading: false,
      isSearch: false
    }
  },
  watch: {

  },
  methods: {
    updateVisible (newVal) {
      console.log('---newVal', newVal)
      this.edit(newVal)
    },
    edit (data) {
      this.loading = true
      this.$store.dispatch('posterOperation', data).then(data => {
        this.loading = false
        this.$message.success('修改成功！')
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    // 创建海报
    toCreate () {
      this.$router.push('/video-manage/video-form/false/0')
    },
    cleanParams () {
      emptyObject(this.filterCondition)
      this.Filter()
    },
    emptySearch () {
      this.searchKey = null
      this.paramsData.searchKey = null
    },
    search (val) {
      this.searchKey = val
      this.isSearch = true
      this.isFromRouter = false
      this.$set(this.paramsData, 'searchKey', val)
    },
    Filter (isFromRouter) {
      this.isSearch = false
      this.isFromRouter = isFromRouter
      for (let key in this.filterCondition) {
        if (!this.filterCondition[key]) {
          this.$delete(this.filterCondition, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.filterCondition)
      }
      this.paramsData = { ...this.filterCondition }
    },
    editItem (row) {
      this.$router.push(`/video-manage/video-form/true/${row.id}`)
    },
    goDetail (row) {
      this.$router.push(`/video-detail/${row.id}`)
    },
    deleteItem (row) {
      this.$confirm(`确定要删除视频：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deletePoster', row.id).then(data => {
          this.$refs.tableWithData.load()
          this.$message.success('删除成功！')
          this.loading = false
        }).catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      })
    },
    // 提交审核
    toSubmit (row) {
      this.$confirm(`确定要提交审核海报：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        let data = {
          id: row.id,
          status: 'SUBMITTED'// 提交审核
        }
        this.$store.dispatch('posterOperation', data).then(data => {
          this.$refs.tableWithData.load()
          this.$message.success('提交成功！')
          this.loading = false
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      })
    },
    // 预览
    preview (data) {
      this.showDialog = true
      this.currentPoster = data
    }
  }
}
</script>
<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.opreation-button{
    :global
    .iconfont{
        margin-right: 10px;
    }
}
</style>
